import React from 'react';
import ScrollReveal from 'scrollreveal';
import about1 from '../assets/img/about/1.png';
import about2 from '../assets/img/about/2.png';
import about3 from '../assets/img/about/3.png';
import about4 from '../assets/img/about/4.png';

const About = () => {
    let aboutMe = React.useRef(null);

    React.useEffect(() => {
        let config = {
            interval: 280,
            delay: 500,
            useDelay: 'onload',
            reset: true,
        };
        aboutMe.current = '.about-me';

        ScrollReveal().reveal(aboutMe.current, config);
    });

    return (
        <>
            {/* About Section */}
            <section id="about" className="about section">
                {/* Section Title */}
                <div className="container section-title" data-aos="fade-up">
                    <h2><i className="bi bi-person navicon"></i> Tentang Saya</h2>
                    <div className="row text-center mt-5">
                        <div className='col-lg-2'></div>
                        <div className="col-lg-8 fs-5 text-muted">
                            Saya adalah seseorang yang mudah bergaul dan beradaptasi dengan lingkungan maupun orang baru.
                            Bagi saya bekerja bersama orang baru memberikan tantangan baru yang cukup menyenangkan.
                            Saya juga dikenal sebagai pendengar yang baik.
                        </div>
                    </div>
                    <div className="row w-100 gy-10 mb-md-20 coba">
                        <div
                            className="col-md-3 px-5 about-me"
                            style={{
                                visibility: "visible",
                                opacity: 1,
                                transition: "all, opacity 0.6s cubic-bezier(0.5, 0, 0, 1)"
                            }}
                        >
                            <div className="text-center mb-10 mb-md-0 ">
                                <img
                                    src={about1}
                                    className="aboutimage"
                                    alt=""
                                />
                                <div className="d-flex mb-4 ms-3">
                                    <span className="badge fw-bolder spanabout me-3 fs-5">
                                        1
                                    </span>
                                    <p className='titleabout'>
                                        Energi
                                    </p>
                                </div>
                                <div className="fs-6 fs-lg-4 ms-3">
                                    Sumber energi saya berasal
                                    dari ide-ide serta pengalaman yang pernah saya lalui.
                                </div>
                            </div>
                        </div>
                        <div
                            className="col-md-3 px-5 about-me"
                            style={{
                                visibility: "visible",
                                opacity: 1,
                                transition: "all, opacity 0.6s cubic-bezier(0.5, 0, 0, 1)"
                            }}
                        >
                            <div className="text-center mb-10 mb-md-0 ">
                                <img
                                    src={about2}
                                    className="aboutimage"
                                    alt=""
                                />
                                <div className="d-flex mb-4 ms-3">
                                    <span className="badge fw-bolder spanabout me-3 fs-5">
                                        2
                                    </span>
                                    <p className='titleabout'>
                                        Pandangan
                                    </p>
                                </div>
                                <div className="fs-6 fs-lg-4 ms-3">
                                    Saya memiliki pandangan luas dan imajinasi yang kuat.
                                </div>
                            </div>
                        </div>

                        <div
                            className="col-md-3 px-5 about-me"
                            style={{
                                visibility: "visible",
                                opacity: 1,
                                transition: "all, opacity 0.6s cubic-bezier(0.5, 0, 0, 1)"
                            }}
                        >
                            <div className="text-center mb-10 mb-md-0 ">
                                <img
                                    src={about3}
                                    className="aboutimage"
                                    alt=""
                                />
                                <div className="d-flex mb-4 ms-3">
                                    <span className="badge fw-bolder spanabout me-3 fs-5">
                                        3
                                    </span>
                                    <p className='titleabout'>
                                        Keputusan
                                    </p>
                                </div>
                                <div className="fs-6 fs-lg-4 ms-3">
                                    Pengambilan keputusan saya cenderung dipandu oleh ketegasan dan pertimbangan yang logis.
                                </div>
                            </div>
                        </div>


                        <div
                            className="col-md-3 px-5 about-me"
                            style={{
                                visibility: "visible",
                                opacity: 1,
                                transition: "all, opacity 0.6s cubic-bezier(0.5, 0, 0, 1)"
                            }}
                        >
                            <div className="text-center mb-10 mb-md-0 ">
                                <img
                                    src={about4}
                                    className="aboutimage"
                                    alt=""
                                />
                                <div className="d-flex mb-4 ms-3">
                                    <span className="badge fw-bolder spanabout me-3 fs-5">
                                        4
                                    </span>
                                    <p className='titleabout'>
                                        Kepribadian
                                    </p>
                                </div>
                                <div className="fs-6 fs-lg-4 ms-3">
                                    Saya adalah seseorang yang sangat spontan dan fleksibel dalam berbagai situasi.
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            {/* /About Section */}
        </>
    )
}

export default About;